const namespaced = true

const defaultState = () => {
  return {
    user: {},
    changePassword: false,
    userTab: 'profile-form',
    countries: [],
    cities: [],
    base: { name: '', id: '' }
  }
}

const state = defaultState()
const actions = {}
const mutations = {
  resetState(state) {
    Object.assign(state, defaultState())
  },
  SET_USER_STATE(state, userState) {
    state.userState = userState
  },
  SET_USER_CITY(state, userCity) {
    state.userCity = userCity
  },
  SET_USER_ADDRESS(state, userAddress) {
    state.userAddress = userAddress
  },
  SET_COUNTRIES(state, countries) {
    state.countries = countries
  },
  SET_CITIES(state, cities) {
    state.cities = cities
  },
  SET_USER_TAB(state, userTab) {
    state.userTab = userTab
  },
  SET_USER(state, user) {
    state.user = user
    state.user.city = user.city && user.city.id ? user.city : state.base
    state.user.state = user.state && user.state.id ? user.state : state.base
    state.user.address = user.address || ''
    state.user.zip = user.zip || ''
  },
  SET_CHANGE_PASSWORD(state, changePassword) {
    state.changePassword = changePassword
  }
}
const getters = {
  getUser(state) {
    return state.user
  }
}

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
